/**
 * Extracts site-dependent route-based parameters
 * and injects them into the DashboardHostRouteShell.
 *
 */

import SiteDashboardPage from './SiteDashboardPage';
import { DashboardHostRouteShell } from './DashboardHostRouteShell';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';

// -- helper functions --

function parseRouteId(value: string | undefined): number | null {
  if (value === undefined) {
    return null;
  }

  const parsed = Number.parseInt(value, 10);
  return Number.isNaN(parsed) ? null : parsed;
}

// -- main component --

export default function SiteDashboardRoute() {
  const params = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const project_id = parseRouteId(params.project_id);
  const site_id = parseRouteId(params.site_id);
  const grid_id = parseRouteId(params.grid_id);
  const isPublic = location.pathname.startsWith('/public');
  const dashboard_only_mode = searchParams.get('dashboard_only_mode');
  const dashboardOnlyMode =
    (dashboard_only_mode !== undefined &&
      dashboard_only_mode !== null &&
      dashboard_only_mode.toLowerCase() !== 'false') ||
    isPublic;

  return (
    <DashboardHostRouteShell
      project_id={project_id}
      site_id={site_id}
      grid_id={grid_id}
      mode={isPublic ? 'public' : 'site'}
      grid_type="grids"
      simplified_view={false}
      dashboard_only_mode={dashboardOnlyMode}
    >
      <SiteDashboardPage />
    </DashboardHostRouteShell>
  );
}
